import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const SessionsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		id: yup.string().required().label("Id"),
		user_id: yup.number().nullable().label("User Id"),
		ip_address: yup.string().nullable().label("Ip Address"),
		user_agent: yup.string().nullable().label("User Agent"),
		payload: yup.string().required().label("Payload"),
		last_activity: yup.number().required().label("Last Activity")
	});
	// form default values
	const formDefaultValues = {
		id: '', 
		user_id: "NULL", 
		ip_address: "NULL", 
		user_agent: '', 
		payload: '', 
		last_activity: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/sessions`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="SessionsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="modificare"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Id *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="id"  onChange={formik.handleChange}  value={formik.values.id}   label="Id" type="text" placeholder="accedere Id"        className={inputClassName(formik?.errors?.id)} />
                                                <ErrorMessage name="id" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                User Id 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="user_id"  onChange={formik.handleChange}  value={formik.values.user_id}   label="User Id" type="number" placeholder="accedere User Id"  min={0}  step="any"    className={inputClassName(formik?.errors?.user_id)} />
                                                <ErrorMessage name="user_id" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Ip Address 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ip_address"  onChange={formik.handleChange}  value={formik.values.ip_address}   label="Ip Address" type="text" placeholder="accedere Ip Address"        className={inputClassName(formik?.errors?.ip_address)} />
                                                <ErrorMessage name="ip_address" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                User Agent 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputTextarea name="user_agent"  className={inputClassName(formik?.errors?.user_agent)}   value={formik.values.user_agent} placeholder="accedere User Agent" onChange={formik.handleChange}   >
                                                </InputTextarea>
                                                <ErrorMessage name="user_agent" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Payload *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputTextarea name="payload"  className={inputClassName(formik?.errors?.payload)}   value={formik.values.payload} placeholder="accedere Payload" onChange={formik.handleChange}   >
                                                </InputTextarea>
                                                <ErrorMessage name="payload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Last Activity *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="last_activity"  onChange={formik.handleChange}  value={formik.values.last_activity}   label="Last Activity" type="number" placeholder="accedere Last Activity"  min={0}  step="any"    className={inputClassName(formik?.errors?.last_activity)} />
                                                <ErrorMessage name="last_activity" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
SessionsEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'sessions',
	apiPath: 'sessions/edit',
	routeName: 'sessionsedit',
	submitButtonLabel: "Update",
	formValidationError: "Il modulo non è valido",
	formValidationMsg: "Si prega di compilare il modulo",
	msgTitle: "Aggiorna registro",
	msgAfterSave: "Record modificato",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SessionsEditPage;
